import { render, staticRenderFns } from "./CompanyMemberPage.vue?vue&type=template&id=0feb2318&scoped=true"
import script from "./CompanyMemberPage.vue?vue&type=script&lang=ts"
export * from "./CompanyMemberPage.vue?vue&type=script&lang=ts"
import style0 from "./CompanyMemberPage.vue?vue&type=style&index=0&id=0feb2318&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0feb2318",
  null
  
)

export default component.exports